<template>
  <!-- begin:form Success -->
    <div class="modal bg-modal" tabindex="-1" id="formSuccess">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center py-2">
              <div class="col-12 text-center">
                <img src="/assets/images/icons/true-circle.png" class="max-50" alt="">
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="font-24 almarai-bold text-center mb-1">{{messageSuccess}}</div>
                <!-- <div class="text-center fonttext-14 gray-color almarai-regular"></div> -->
              </div>
            </div>
            <div class="row py-3">
              <router-link to="/">
                <div class="col-12 mouse-hand" id="back">
                  <div class="back almarai-bold text-center">{{$t('formSuccess.title_4')}}</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:form Success -->
</template>
<script>
export default {
  name: "successForm",
  props: {
    messageSuccess: "",
  }
}
</script>